import React, { useState } from "react";
import { Card, Button, Container, Row, Col, Form } from "react-bootstrap";
import { FaPaypal,FaCheckCircle, FaCreditCard, FaUniversity, FaMoneyCheckAlt } from "react-icons/fa";
import "./Card.css";

const GetStarted = () => {
  const plans = [
    { name: "Basic Plan", price: 99 },
    { name: "Elite Plan", price: 149 },
    { name: "Premium Plan", price: 199 },
    { name: " Engagement  Basic Plan", price: 99 },
    { name: "Engagement Elite Plan", price: 199 },
    { name: "Engagement Premium Plan", price: 299 },
  ];

  const planb = [
    {
      price: "99",
      billing: "Basic Plan",
      description:
        "The best way to grow quickly and with more advanced targeting. Ideal for fast-growing influencers and brands.",
      buttonText: "$3.30 Per Day",
      features: [
        "2,500 - 3,500 Followers /mo",
        "Follower Growth Within 2 Days",
        "Guaranteed Results Or It's Free",
        "Los Angeles Team & Support",
        "Engaged, Organic Followers",
        "Hands Off For You",
        "Advanced AI Targeting",
        "Dedicated 24/7 Support",
      ],
      // stripeLink: "https://buy.stripe.com/4gw6qf5BgcfebksdRK", // Stripe link for Basic Plan
    },
    {
      price: "149",
      billing: "Elite Plan",
      description:
        "Ideal for businesses looking for rapid audience growth with real engagement and targeted strategy.",
      buttonText: "$4.97 Per Day",
      features: [
        "5,000 - 7,000 Followers /mo",
        "Priority Growth & Engagement",
        "Dedicated Account Manager",
        "Targeted Follower Strategy",
        "Brand Consultation Included",
        "Hands Off For You",
        "Advanced AI Targeting",
        "24/7 VIP Support",
      ],
      // stripeLink: "https://buy.stripe.com/cN2bKz7Joenm6089Bl", // Stripe link for Elite Plan
    },
    {
      price: "199",
      billing: "Premium Plan",
      description:
        "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
      buttonText: "$6.63 Per Day",
      features: [
        "10,000+ Followers /mo",
        "Maximum Engagement",
        "Personalized Growth Plan",
        "Expert Strategy Calls",
        "Exclusive AI Targeting",
        "Hands Off For You",
        "Organic Audience Growth",
        "Dedicated 24/7 VIP Support",
      ],
      // stripeLink: "https://buy.stripe.com/eVaaGv1l0a76ewEbJj", // Stripe link for Premium Plan
    },

     // 2
     {
      price: "99",
      billing: " Engagement  Basic Plan",
      description:
        "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
      buttonText: "$3.30 Per Day",
      features: [
        "Let's increase your engagement upto 3% to 5% gradually step by step which will make your posts to get visible to your audience with lot of interactions in terms",

        "We focus and make sure that your profile will be pushed to the people of same interest..",
        "Same for location. We will target your locations and make sure that your each post will be pushed to explore page of your familiar locations.",

        "It would be  1500-2000 plus likes+ 30 plus comments + 15k -20k reels video views  on your each and every post and it cost for you 150$ for a month",
      ],
      
    },

    {
      price: "199",
      billing: " Engagement  Elite Plan",
      description:
        "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
      buttonText: "$6.63 Per Day",
      features: [
        "Let's increase your engagement upto 5% to 10% gradually step by step which will make your posts to get visible to your audience with lot of interactions in terms",

        "We focus and make sure that your profile will be pushed to the people of same interest..",
        "Same for location. We will target your locations and make sure that your each post will be pushed to explore page of your familiar locations.",

        "It would be  2500-3000 plus likes+ 30 plus comments + 20k -30k reels video views  on your each and every post and it cost for you 199$ for a months",
      ],
      
    },

    {
      price: "299",
      billing: " Engagement  Premium Plan",
      description:
        "The ultimate plan for brands and influencers who want the fastest and most effective growth strategy.",
      buttonText: "$9.97 Per Day",
      features: [
        "Let's increase your engagement upto 5% to 10% gradually step by step which will make your posts to get visible to your audience with lot of interactions in terms",

        "We focus and make sure that your profile will be pushed to the people of same interest..",
        "Same for location. We will target your locations and make sure that your each post will be pushed to explore page of your familiar locations.",

        "It would be  2500-3000 plus likes+ 30 plus comments + 20k -30k reels video views  on your each and every post and it cost for you 199$ for a months",
      ],
      
    },
  ];

  const [selectedPlan, setSelectedPlan] = useState(plans[0]); // Default Basic Plan
  const [paymentMethod, setPaymentMethod] = useState("paypal");
  const [userData, setUserData] = useState({ name: "", email: "" });
  const [duration, setDuration] = useState(1);

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    const totalPrice = selectedPlan.price * duration;
    let paymentLink = "";

    switch (paymentMethod) {
      case "paypal":
        paymentLink = `https://www.paypal.com/payment?amount=${totalPrice}&email=${userData.email}`;
        break;
      
      case "revolut":
        paymentLink = `https://revolut.me/ioanayoyo/payment?amount=${totalPrice}&email=${userData.email}`;
        break;
      case "stripe":
        paymentLink = "https://buy.stripe.com/4gw6qf5BgcfebksdRK";
        break;
      default:
        alert("Invalid payment method selected.");
        return;
    }
    window.location.href = paymentLink;
  };

  return (
    <>
      <div className="container-xxl py-5 hero-header1">
        <div className="container my-5 py-5 px-lg-5">
          <div className="row g-5 py-5">
            <div className="col-12 text-center">
              <h1 className="text-white animated slideInDown">Place An Order</h1>
              <hr className="bg-white mx-auto mt-0" style={{ width: "90px" }} />
            </div>
          </div>
        </div>
      </div>

       {/* Packages */}
       
            
          
          
            <Container className="py-5">
              <Row className="gy-4">
                {planb.map((planb, index) => (
                  <Col key={index} md={6} lg={4}>
                    <Card className="border-black border-2 pricing-card border rounded shadow-sm position-relative text-center p-3">
                      <div className="button-wrapper">
                        <Button className="plan-button">{planb.buttonText}</Button>
                      </div>
        
                      <Card.Body className="pt-5">
                        <h4 className="fw-bold">${planb.price}</h4>
                        <p className="text-muted" id="billing">{planb.billing}</p>
                        <p className="text-secondary">{planb.description}</p>
                        <hr />
        
                        <ul className="list-unstyled text-start px-3">
                          {planb.features.map((feature, i) => (
                            <li key={i} className="d-flex align-items-center mb-2">
                              <FaCheckCircle className="text-success me-2" />
                              {feature}
                            </li>
                          ))}
                        </ul>
        
                        <Button variant="outline-primary" className="mt-3 viewbtn">
                          Get Started Now
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>

              </Container>


       {/* Packages end */}
      <Container className="my-5 pt-5" id="getform">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="shadow">
              <Card.Body>
                <h2 className="text-center mb-4">Payment Details</h2>
                <Form onSubmit={handlePaymentSubmit}>
                  <Form.Group className="mb-3" id="payment-section">
                    <Form.Control
                      type="text"
                      placeholder="Enter your name"
                      required
                      value={userData.name}
                      onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      required
                      value={userData.email}
                      onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3 form1">
                    <Form.Label>Select Plan</Form.Label>
                    <Form.Select
                      value={selectedPlan.name}
                      onChange={(e) => {
                        const plan = plans.find((p) => p.name === e.target.value);
                        setSelectedPlan(plan);
                      }}
                      required
                    >
                      {plans.map((plan) => (
                        <option key={plan.name} value={plan.name}>
                          {plan.name} - ${plan.price}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3 form1">
                    <Form.Label>Select Duration (Months)</Form.Label>
                    <Form.Select
                      value={duration}
                      onChange={(e) => setDuration(parseInt(e.target.value))}
                      required
                    >
                      {[1, 2, 3, 4, 5, 6,7, 8, 9, 10, 11, 12].map((num) => (
                        <option key={num} value={num}>{num} Month{num > 1 ? "s" : ""}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Card className="mb-3">
                    <Card.Body>
                      <p><strong>Selected Plan:</strong> {selectedPlan.name}</p>
                      <p><strong>Duration:</strong> {duration} month(s)</p>
                      <p><strong>Total Amount:</strong> ${selectedPlan.price * duration}</p>
                    </Card.Body>
                  </Card>

                  <Form.Group className="mb-4 form1">
                    <Form.Label>Select Payment Method</Form.Label>
                    <Form.Select
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      required
                    >
                      <option value="paypal"><FaPaypal className="me-2" /> PayPal</option>
                      {/* <option value="credit"><FaCreditCard className="me-2" />Strips</option> */}
                      <option value="revolut"><FaMoneyCheckAlt className="me-2" /> Revolut</option>
                      <option value="stripe">Stripe</option>
                    </Form.Select>
                  </Form.Group>

                  <Button type="submit" className="w-100 proceedbtn">Proceed to Payment</Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GetStarted;
